import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { WorkorderCardActionsComponent } from '../workorder-card-actions/workorder-card-actions.component';
import { WorkOrdersQuery } from '../state/workorders.query';
import { Observable } from 'rxjs';
import { WorkOrderDto } from 'src/api';
import { WorkorderBadgeComponent } from '../workorder-badge/workorder-badge.component';
import { LocalizedDatePipe } from 'src/app/shared/localizedDatePipe';
@Component({
  selector: 'app-workorder-card',
  standalone: true,
  templateUrl: './workorder-card.component.html',
  styleUrls: ['./workorder-card.component.scss'],
  imports: [CommonModule, RouterModule, WorkorderCardActionsComponent, WorkorderBadgeComponent, LocalizedDatePipe],
})
export class WorkorderCardComponent implements OnInit {
  @Input({ required: true }) workOrderId!: number | undefined;
  workOrder$!: Observable<WorkOrderDto | undefined>;

  constructor(private workOrdersQuery: WorkOrdersQuery) {}

  ngOnInit(): void {
    this.workOrder$ = this.workOrdersQuery.selectEntity(this.workOrderId as number);
  }
}
